module.exports = __webpack_public_path__ + "img/done.3eaff7a0.webp";